"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const FeatureIcon_1 = __importDefault(require("../FeatureIcon/FeatureIcon"));
const Spacer_1 = __importDefault(require("../Spacer/Spacer"));
class InformationBox extends React.Component {
    render() {
        const className = classnames_1.default({
            'information-box': true,
            [`information-box-${this.props.color}`]: true,
            'information-box-full': this.props.fullWidth === true,
        });
        return (React.createElement("div", { className: className },
            this.getTitle(),
            React.createElement(Spacer_1.default, { size: "xxs" }),
            React.createElement("div", null, this.props.children)));
    }
    getTitle() {
        if (this.props.icon && this.props.iconColor) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "title-with-icon-outer" },
                    React.createElement("div", { className: "title-with-icon-inner" },
                        React.createElement(FeatureIcon_1.default, { icon: this.props.icon, color: this.props.iconColor })),
                    React.createElement("h2", null, this.props.title))));
        }
        else {
            return React.createElement("h2", null, this.props.title);
        }
    }
}
InformationBox.defaultProps = {
    color: 'default',
    fullWidth: false,
    iconColor: 'blue',
};
exports.default = InformationBox;
//# sourceMappingURL=InformationBox.js.map